function isIpAddress(hostname: string) {
  return /^\d{1,3}(?:\.\d{1,3}){3}$/.test(hostname) || hostname.includes(':')
}

function isLoopback(hostname: string) {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1' || hostname === '[::1]'
}

export function googleOAuthOriginWarning(protocol: string, hostname: string) {
  if (isLoopback(hostname)) return ''
  if (protocol !== 'https:') return 'O login Google exige HTTPS fora do localhost.'
  if (isIpAddress(hostname)) return 'O login Google não aceita um endereço IP como origem web.'
  return ''
}

export function localhostDevelopmentUrl(location: Pick<Location, 'port' | 'pathname' | 'search' | 'hash'>) {
  const port = location.port ? `:${location.port}` : ''
  return `http://localhost${port}${location.pathname}${location.search}${location.hash}`
}
